// extracted by mini-css-extract-plugin
module.exports = {"bgImage":"styles_bgImage__NMFkW"};